import React from 'react';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setConfirmationModal, useConfirmBackNavigation } from 'modules/global';
import { LoadingTopicTest, TopicTest, useThemedTestQuiz, useTopicTestById } from 'modules/mavzuli-test';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const dispatch = useAppDispatch();
  const testId = (query?.testId as string)?.split('-')[0];
  const { data: testById } = useTopicTestById(testId);
  const userDataLoading = useAppSelector(state => state.user.loading);
  const { isLoading: isTestDataLoading } = useThemedTestQuiz(testId);

  useConfirmBackNavigation(() => {
    dispatch(setConfirmationModal(true));
  });

  if (userDataLoading || isTestDataLoading) {
    return <LoadingTopicTest />;
  }

  return (
    <>
      <NextHead
        title={t('meta.topic_test_solve.title', {
          subject: testById?.subject_name || '',
          lesson: testById?.lesson_name || ''
        })}
        hasCanonical
        description={t('meta.topic_test_solve.description', {
          subject: testById?.subject_name || '',
          lesson: testById?.lesson_name || ''
        })}
      />
      <TopicTest />
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale, params }) => {
  const testId = (params?.testId as string)?.split('-')[0];

  if (!Number.isInteger(Number(testId))) {
    return {
      notFound: true
    };
  }

  const res = await fetch(`${process.env.NEXT_PUBLIC_TEST_URL}/client/themed-order?test_id=${testId}`);
  const test = (await res.ok) ? await res.json() : null;

  if (!test) {
    return {
      notFound: true
    };
  }

  const canonicalUrl =
    locale === 'uz'
      ? `${process.env.NEXT_PUBLIC_FRONT_URL}/mavzuli-test/${params?.subject}/${params?.testId}`
      : `${process.env.NEXT_PUBLIC_FRONT_URL}/${locale}/mavzuli-test/${params?.subject}/${params?.testId}`;

  return {
    props: {
      messages: (await import(`../../../messages/${locale}.json`)).default,
      canonicalUrl,
      subject: params?.subject || '',
      testId: params?.testId || ''
    }
  };
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  };
}
